'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
var fonts = require('../../../../enums/fonts.js');
var headings = require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
var font = require('../../../../styles/styled-components/font.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
var heading = require('../../../../styles/styled-components/heading.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
var baseHeading = require('../base-heading/base-heading.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseStandardHeading = (props)=>{
    const { align , children , className , color , level , size , transform , weight , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(baseHeading.BaseHeading, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-heading__standard': true,
            [`bf-heading__standard--${level}`]: level,
            [`bf-heading__standard--align-${align}`]: !!align,
            [`bf-heading__standard--color-${color}`]: !!color,
            [`bf-heading__standard--size-${size}`]: !!size,
            [`bf-heading__standard--transform-${transform}`]: !!transform,
            [`bf-heading__standard--weight-${weight}`]: !!weight,
            [`${className}`]: className
        }),
        level: level
    }), children);
};
const Heading = styled__default.default(BaseStandardHeading)`
  box-sizing: border-box;
  display: block;
  ${({ level  })=>heading.getHeadingLevel({
        level
    })}
  ${({ align  })=>font.getFontAlignment({
        align
    })}
  ${({ color , theme  })=>font.getFontColor({
        color,
        darkMode: theme.darkMode
    })}
  ${({ size  })=>font.getFontSize({
        size
    })}
  ${({ transform  })=>font.getFontTransform({
        transform
    })}
  ${({ weight  })=>font.getFontWeight({
        weight
    })}
`;
/**
 * A component for the six levels of section headings.
 * `<h1>` is the highest section level and `<h6>` is the lowest.
 * Headings can contain [phrasing content](https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Content_categories#phrasing_content) like `<img>` and `<a>` tags. All text needs to be translated by your app.
 *
 * IMPORTANT: You will need to have Brandfolder's `@font-face` for Circular.
 * Consider using `<BrandfolderGlobalStyles>` component with `styled-components`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Heading_Elements
 *
 * @param props StandardHeadingProps
 * @returns FunctionComponent<StandardHeadingProps>
 */ const StandardHeading = (props)=>{
    const { align =fonts.FontAlignments.Left , color =fonts.FontColors.Default , level =headings.HeadingLevels.h1 , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Heading, _extends({}, otherProps, {
        align: align,
        color: color,
        level: level
    })));
};

exports.BaseStandardHeading = BaseStandardHeading;
exports.StandardHeading = StandardHeading;
//# sourceMappingURL=standard-heading.js.map
